import React from "react";
import Divider from "@mui/material/Divider";

const MiddleInsetVerticalDivider = (props) => (
  <Divider orientation="vertical" variant="middle" flexItem {...props} />
);

export default MiddleInsetVerticalDivider;
